import { cva, type VariantProps } from 'class-variance-authority'
import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

const billingBalanceDisplayVariants = cva('billing-balance-display font-semibold tabular-nums', {
  variants: {
    size: {
      sm: 'text-lg',
      md: 'text-2xl',
      lg: 'text-4xl',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export interface BillingBalanceDisplayProps
  extends VariantProps<typeof billingBalanceDisplayVariants> {
  amount: number
  currency?: string
  className?: string
}

const formatCurrency = (amount: number, currency: string): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return formatter.format(amount)
}

const BillingBalanceDisplayBase: React.FC<BillingBalanceDisplayProps> = ({
  amount,
  currency = 'USD',
  size,
  className,
}): ReactNode => (
  <span className={cn(billingBalanceDisplayVariants({ size }), className)}>
    {formatCurrency(amount, currency)}
  </span>
)

export const BillingBalanceDisplay = memo(BillingBalanceDisplayBase)

BillingBalanceDisplay.displayName = 'BillingBalanceDisplay'

export { billingBalanceDisplayVariants }
